// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ISetSelfAssessmentFormApi,
  ISetSelfAssessmentFormApiRequest,
  ISetSelfAssessmentFormApiGetFormListDropdownAttrs,
  ISetSelfAssessmentFormApiGetListDropdownResponse,
} from 'interfaces/back-office/set-self-assessment-form/set-self-assessment-form-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class SetSelfAssessmentFormApi extends BaseApi<ISetSelfAssessmentFormApi> implements ISetSelfAssessmentFormApiRequest {
  readonly url = ApiConstant.SET_SELF_ASSESSMENT_FORM_URL
  private setSelfAssessmentFormUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get Form List Dropdown
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ISetSelfAssessmentFormApiGetFormListDropdownAttrs} payload
   *
   * @return {Promise<ISetSelfAssessmentFormApiGetListDropdownResponse>} Promise<ISetSelfAssessmentFormApiGetListDropdownResponse>
   */
  async setSelfAssessmentForm_getDropdown(
    payload: ISetSelfAssessmentFormApiGetFormListDropdownAttrs,
  ): Promise<ISetSelfAssessmentFormApiGetListDropdownResponse> {
    try {
      const response = await this.POST(`${this.setSelfAssessmentFormUrl}/dropdown`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
